import $ from 'jquery';
import Gallery from './gallery';
import Helper from '../utils/helper';
import Tracking from '../utils/tracking';

export default class Landing {
    constructor(option) {
        var params = {
            'state': undefined,
            'slide': undefined
        };
        $.extend(params, option);

        this.gallery = new Gallery();

        this.setEvents();

        if (params.state && params.slide) {
            this.showGallery(params.state, params.slide);
        }
    }

    setEvents() {
        $('.state').on('click', this.openGallery.bind(this));
        $('#scroll-to-state').change(this.scrollToState);
        $('.social__facebook').on('click', this.shareOnFacebook.bind(this));
        $('.social__twitter').on('click', this.shareOnTwitter.bind(this));
        $('.social__google_plus').on('click', this.shareOnGooglePlus.bind(this));
        $('.state')
            .mouseenter(this.showOverlayOnState)
            .mouseleave(this.hideOverlayOnState);
    }

    showOverlayOnState() {
        $(this).addClass('hover');
    }

    hideOverlayOnState() {
        $(this).removeClass('hover');
    }

    openGallery(event) {
        let state = $(event.target).parent().data('state');

        this.showGallery(state);
    }

    shareOnFacebook(event) {
        Tracking.track({
            hitType : 'social',
            socialNetwork : 'Facebook',
            socialAction : 'share',
            socialTarget : window.location.href
        });

        Helper.openToNewWindow(event, 580, 352);
    }

    shareOnTwitter(event) {
        Tracking.track({
            hitType : 'social',
            socialNetwork : 'Twitter',
            socialAction : 'tweet',
            socialTarget : window.location.href
        });

        Helper.openToNewWindow(event, 520, 550);
    }

    shareOnGooglePlus(event) {
        Tracking.track({
            hitType : 'social',
            socialNetwork : 'Google +',
            socialAction : 'share',
            socialTarget : window.location.href
        });

        Helper.openToNewWindow(event, 600, 600);
    }

    showGallery(state, slide=1) {
        this.gallery.show(state, slide);

        window.history.pushState(null, null, `/state/${state}/slide/${slide}`);

        Tracking.track({
            hitType: 'event',
            eventAction: 'Clicked On',
            eventCategory: 'Open Gallery',
            eventLabel: state
        });
    }

    scrollToState() {
        let state = this.value,
            $state = $(state),
            stateOffset = $state.offset().top,
            stateHeight = $state.height(),
            windowHeight = $(window).height(),
            offset;

        if (stateHeight < windowHeight) {
            offset = stateOffset - ((windowHeight / 2) - (stateHeight / 2));
        } else {
            offset = stateOffset;
        }

        $('html, body').animate({
            scrollTop: offset
        }, 400);
    }
}



/** WEBPACK FOOTER **
 ** ./frontend/js/views/landing.js
 **/